<template>
  <div
    class="main-container"
    v-if="!jump"
  >
    <!-- 添加编辑 -->
    <el-dialog
      :title="editType==1?'添加':'编辑'"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        ref="editForm"
        :rules="editRules"
      >
        <el-row>
          <el-form-item
            label="SN码"
            prop="DeviceNo"
          >
            <el-input
              v-model="editForm.DeviceNo"
              autocomplete="off"
              placeholder="请输入SN码"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="设备名称"
              prop="DeviceName"
            >
              <el-input
                v-model="editForm.DeviceName"
                autocomplete="off"
                placeholder="请输入设备名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品型号">
              <el-select
                v-model="editForm.ProductID"
                placeholder="请选择产品型号"
                style="width:100%"
                filterable
                clearable
              >
                <el-option
                  v-for="item in productOptions"
                  :key="item.ProductID"
                  :label="item.Name"
                  :value="item.ProductID"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所在项目">
              <el-select
                v-model="editForm.PrjID"
                placeholder="请选择项目"
                style="width:100%"
                filterable
                clearable
              >
                <el-option
                  v-for="item in prjOptions"
                  :key="item.PrjID"
                  :label="`${item.PrjName}（${item.PrjCode}）`"
                  :value="item.PrjID"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="IP地址">
              <el-input
                v-model="editForm.IPAddress"
                autocomplete="off"
                placeholder="请输入IP地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="通讯方式"
              prop="CommunicateMode"
            >

              <el-select
                v-model="editForm.CommunicateMode"
                placeholder="请选择通讯方式"
                style="width:100%"
                clearable
              >
                <el-option
                  v-for="item in communicateOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="模式"
              prop="Mode"
            >
              <el-select
                v-model="editForm.Mode"
                placeholder="请选择模式"
                style="width:100%"
                clearable
              >
                <el-option
                  v-for="item in modeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入备注"
              v-model="editForm.Remark"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('editForm')"
          :loading="sumbitLoading"
        >确 定</el-button>
      </div>
    </el-dialog>
    <div class="toolBox">
      <div class="leftBox">
        <el-form
          :inline="true"
          :model="searchForm"
          class="searchForm"
          size="mini"
        >

          <el-form-item
            label="状态"
            style="margin-bottom:0"
            class="status"
          >
            <el-select
              v-model="searchForm.IsConnected"
              placeholder="请选择状态"
              style="width:75px"
              clearable
              @change="changeStatus"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item
            label="设备号"
            style="margin-bottom:0;"
          >
            <el-input
              v-model.trim="searchForm.DeviceNo"
              @change="inputFunction"
              placeholder="请输入SN码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备名称"
            style="margin-bottom:0"
          >
            <el-input
              v-model.trim="searchForm.DeviceName"
              @change="inputFunction3"
              placeholder="请输入设备名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="IMEI"
            style="margin-bottom:0"
          >
            <el-input
              v-model.trim="searchForm.IMEI"
              @change="inputFunction4"
              placeholder="请输入IMEI"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="ICCID"
            style="margin-bottom:0"
          >
            <el-input
              v-model.trim="searchForm.ICCID"
              @change="inputFunction2"
              placeholder="请输入ICCID"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="search"
            >查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="rightBox">
        <el-button
          icon="el-icon-plus"
          @click="add"
          v-if="Role===1"
           size="mini"
        >添加</el-button>
        <!-- <excel-import
          :on-success="onSuccess"
          style="margin-left: 10px;"
        >
          <el-button
            icon="el-icon-download"
            type="warning"
            size="mini"
          >导入</el-button>
        </excel-import> -->

        <excel-export
          :sheet="sheet"
          filename="设备管理"
          ref="excelExport"
          :manual="true"
          style="margin: 0 10px;"
        >
          <el-button
            icon="el-icon-upload2"
            type="success"
             size="mini"
            @click="getList(searchForm,true)"
            :loading="exportLoading"
          >导出</el-button>
        </excel-export>
        <el-button
          type="primary"
          icon="el-icon-sort"
          v-if="Role!=3"
           size="mini"
          @click="toRemove"
        >设备转移</el-button>
      </div>
      <!--设备转移 -->
      <el-dialog
        title="设备转移"
        :visible.sync="deviceRemove.visible"
        :close-on-click-modal="false"
        width="30vw"
      >
        <el-form
          :model="deviceRemove.form"
          label-width="120px"
          ref="deviceRemoveForm"
          :rules="deviceRemove.rules"
        >
          <el-row>
            <el-form-item
              label="转入项目编号"
              prop="PrjCode"
            >
              <el-input
                v-model="deviceRemove.form.PrjCode"
                autocomplete="off"
                placeholder="请输入转入项目编号"
              ></el-input>
            </el-form-item>
          </el-row>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="deviceRemove.visible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitForm('deviceRemoveForm')"
            :loading="sumbitLoading"
          >确 定</el-button>
        </div>

      </el-dialog>
    </div>
    <div class="content">
      <el-table
        :data="table.data"
        border
        height="100%"
        stripe
        style="width: 100%"
        :header-cell-style="{background:'#2c86d1',color:'white',textAlign:'center'}"
        :cell-style="{textAlign:'center'}"
        v-loading="table.loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="40"
          align="center"
        />
        <el-table-column
          prop="IsConnected"
          label="状态"
          align="center"
          fixed="left"
          width="50"
        >
          <template slot-scope="scope">
            <i
              v-if="scope.row.IsConnected"
              class="el-icon-success"
              style="color:#67c23a;font-size:24px"
            ></i>
            <i
              v-else
              class="el-icon-error"
              style="color:#f56c6c;font-size:24px"
            ></i>
          </template>
        </el-table-column>
        <el-table-column
          prop="PrjName"
          label="项目名称"
          fixed="left"
          width="120"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="ProductName"
          label="产品型号"
          fixed="left"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="DeviceNo"
          label="SN码"
          fixed="left"
          width="140"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
         <el-table-column
          prop="DeviceName"
          label="设备名称"
          width="120"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="CommunicateMode"
          label="通讯方式"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.CommunicateMode===1">以太网</div>
            <div
              v-if="scope.row.CommunicateMode===2"
              type="danger"
            >4G</div>
          </template>
        </el-table-column>
         <el-table-column
          prop="Mode"
          label="状态模式"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.Mode===0">调试模式</div>
            <div
              v-if="scope.row.Mode===1"
              type="danger"
            >工程模式</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="IMEI"
          label="IMEI"
          width="200"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          prop="ICCID"
          label="ICCID"
          width="200"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="CSQ"
          label="信号值"
          width="200"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="LastOnLineTime"
          label="最后更新时间"
          width="160"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          prop="Ver"
          label="版本"
          min-width="160"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="UserName"
          label="创建人"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="UpdateTime"
          label="创建时间"
          width="160"
          :show-overflow-tooltip="true"
        >
        </el-table-column>


        <el-table-column
          fixed="right"
          label="操作"
          width="240"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="edit(scope.row)"
              v-if="Role!=3"
            >编辑</el-button>
            <el-popconfirm
              :title="`确认删除设备「${scope.row.DeviceName}」吗`"
              style="margin:0 10px"
              v-if="Role!=3"
              @confirm="del(scope.row.DeviceID)"
            >
              <el-button
                slot="reference"
                size="mini"
                type="danger"
              >删除</el-button>
            </el-popconfirm>
            <el-button
              size="mini"
              type="primary"
              @click="config(scope.row.DeviceID,scope.row.DeviceNo)"
            >远程配置</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="listPage admin_page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="table.pageNum"
        :page-sizes="[15,30,45]"
        :page-size="table.pageSize"
        layout="total,prev, pager, next, sizes, jumper"
        :total="table.total"
        background
      >
      </el-pagination>
    </div>

  </div>
  <div
    class="main-container"
    style="border-top:2px solid white"
    v-else
  >
    <el-button
      class="closeConfig"
      type="primary"
      @click="closeJump"
      v-show="!jumpLoading"
    >关闭配置</el-button>
    <div
      class="jump-loader"
      element-loading-text="项目加载中"
      v-loading="jumpLoading"
      v-if="jumpLoading"
    >
    </div>
    <iframe
      :src="jumpUrl"
      width="100%"
      height="100%"
      frameborder="0"
      id="jumpIframe"
    />
  </div>
</template>

<script>
import { ExcelExport, ExcelImport } from "pikaz-excel-js";
import { mapGetters, mapState } from "vuex";
export default {
  components: {
    ExcelExport,
    ExcelImport,
  },
  data() {
    return {
      deviceRemove: {
        form: {},
        visible: false,
        rules: {
          PrjCode: [
            {
              required: true,
              message: "请输入转入项目编号",
              trigger: "blur",
            },
          ],
        },
      },
      isJump: false,
      jumpLoading: false,
      jump: false,
      jumpUrl: `${window.location.protocol}//${window.location.hostname}:${
        window.location.port ? window.location.port : ""
      }/home`,
      //导出集合
      exportList: [],
      //导出数据:
      sheet: [],
      exportLoading: false,
      sumbitLoading: false,
      table: {
        data: [],
        loading: false,
        pageSize: 15, //每页显示条数
        pageNum: 1, //当前页数
        total: 0, //总条数
      },
      searchForm: {
        DeviceNo: "",
        ICCID: "",
        DeviceName: "",
        IMEI: "",
        IsConnected: true,
      },
      productOptions: [],
      prjOptions: [],
      modeOptions: [
        {
          value: 0,
          label: "调试模式",
        },
        {
          value: 1,
          label: "工程模式",
        },
      ],
      statusOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: true,
          label: "在线",
        },
        {
          value: false,
          label: "离线",
        },
      ],
      communicateOptions: [
        {
          value: 1,
          label: "以太网",
        },
        {
          value: 2,
          label: "4G",
        },
      ],
      editType: 1, //1添加2编辑
      editFormVisible: false,
      editForm: {},
      checkList: [],
      editRules: {
        DeviceNo: [
          {
            required: true,
            message: "请输入SN码",
            trigger: "blur",
          },
        ],
        DeviceName: [
          {
            required: true,
            message: "请输入设备名称",
            trigger: "blur",
          },
        ],
        CommunicateMode: [
          {
            required: true,
            message: "请选择通讯方式",
            trigger: "change",
          },
        ],
        Mode: [
          {
            required: true,
            message: "请选择模式",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters([
      "SessionId",
      "UserId",
      "UserInfo",
      "DeviceID",
      "GatewayCode",
      "Role",
    ]),
  },
  mounted() {
    this.getList(this.searchForm);
    if (this.$route.query.DeviceID && this.$route.query.DeviceNo) {
      this.isJump = true;
      this.config(this.DeviceID, this.GatewayCode, true);
    } else {
      this.isJump = false;
    }
  },
  methods: {
    changeStatus(val) {
      this.table.pageNum = 1;
      this.table.pageSize = 15;
      this.getList(this.searchForm);
    },
    closeJump() {
      if (this.isJump) {
        this.$store.commit("settings/SET_JUMP_STATUS", true);
        this.$router.push("/admin/project");
      } else {
        this.jump = false;
      }
    },
    handleSelectionChange(val) {
      this.checkList = val;
    },
    onSuccess(data, file) {
      data[0].data.shift();
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: [...data[0].data],
      };
      this.$api
        .axios_http(this.$gd.admin.device.import, obj, "POST")
        .then((res) => {
          if (res.ReturnCode == 0) {
            this.$message.success("导入成功");
            this.getList(this.searchForm);
          } else {
            this.$message.error(res.Error);
          }
        });

      console.log(data[0].data);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "editForm") {
            this.sumbit();
          }
          if (formName == "deviceRemoveForm") {
            this.Remove();
          }
        } else {
          return false;
        }
      });
    },
    //翻页事件
    handleSizeChange(val) {
      this.table.pageSize = val;
      this.getList(this.searchForm);
    },
    //翻页事件
    handleCurrentChange(val) {
      this.table.pageNum = val;
      this.getList(this.searchForm);
    },
    add() {
      this.reset();
      this.editType = 1;
      this.getPrjList()
        .then(() => {
          return this.getProductList();
        })
        .then(() => {
          this.editFormVisible = true;
        });
    },
    edit(data) {
      this.reset();
      this.editForm = JSON.parse(JSON.stringify(data));
      this.editType = 2;
      this.getPrjList()
        .then(() => {
          return this.getProductList();
        })
        .then(() => {
          this.editFormVisible = true;
        });
    },
    // 表单重置
    reset() {
      this.editForm = {
        DeviceNo: null,
        DeviceName: null,
        ProductID: null,
        PrjID: null,
        IPAddress: null,
        CommunicateMode: null,
        Mode: null,
        Remark: null,
      };
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].resetFields();
      }
    },
    toRemove() {
      if (this.checkList && this.checkList.length > 0) {
        this.deviceRemove.form = {
          PrjCode: null,
        };
        if (this.$refs["deviceRemoveForm"]) {
          this.$refs["deviceRemoveForm"].resetFields();
        }
        this.deviceRemove.visible = true;
      } else {
        this.$message.error("至少选择一条数据");
      }
    },
    async Remove() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          PrjCode: this.deviceRemove.form.PrjCode,
          DeviceIDs: [],
        },
      };
      this.checkList.forEach((item) => {
        obj.Params.DeviceIDs.push(item.DeviceID);
      });
      const res = await this.$api.axios_http(
        this.$gd.admin.device.transPrj,
        obj,
        "POST"
      );

      if (res.ReturnCode == 0) {
        this.deviceRemove.visible = false;
        this.getList(this.searchForm);
        this.$message.success("操作成功");
      } else {
        this.$message.error(res.Error);
      }
    },
    inputFunction(e) {
      this.searchForm.DeviceNo = e;
      if (e != "") {
        this.searchForm.IsConnected = "";

        this.getList(this.searchForm);
      }
    },
    inputFunction2(e) {
      this.searchForm.ICCID = e;
      if (e != "") {
        this.searchForm.IsConnected = "";

        this.getList(this.searchForm);
      }
    },
    inputFunction3(e) {
      this.searchForm.DeviceName = e;
      if (e != "") {
        this.searchForm.IsConnected = "";

        this.getList(this.searchForm);
      }
    },
    inputFunction4(e) {
      this.searchForm.IMEI = e;
      if (e != "") {
        this.searchForm.IsConnected = "";

        this.getList(this.searchForm);
      }
    },
    search() {
      this.table.pageNum = 1;
      this.table.pageSize = 15;
      if (
        this.searchForm.DeviceNo != "" ||
        this.searchForm.ICCID != "" ||
        this.searchForm.DeviceName != "" ||
        this.searchForm.IMEI != ""
      ) {
        this.searchForm.IsConnected = "";
      }
      this.getList(this.searchForm);
    },
    async getList(searchForm, isExport = false) {
      let obj;
      if (isExport) {
        this.sumbitLoading = true;
        obj = {
          SessionId: this.SessionId,
          UserId: this.UserId,
          ClientName: "Hoko.Iot.Web.System",
          Params: {
            SearchList: [],
            SortList: [
              {
                SortDescend: true,
                SortProperty: "UpdateTime",
              },
            ],
          },
        };
      } else {
        this.table.loading = true;
        obj = {
          SessionId: this.SessionId,
          UserId: this.UserId,
          ClientName: "Hoko.Iot.Web.System",
          Params: {
            PageNumber: this.table.pageNum,
            PageSize: this.table.pageSize,
            SearchList: [],
            SortList: [
              {
                SortDescend: true,
                SortProperty: "UpdateTime",
              },
            ],
          },
        };
      }

      if (searchForm) {
        Object.keys(searchForm).forEach(function (key) {
          if (searchForm[key] === true || searchForm[key] === false) {
            if (key == "IsConnected") {
              obj.Params.SearchList.push({
                CompareType: "Equal",
                PropertyName: key,
                PropertyValue: searchForm[key],
              });
            } else {
              obj.Params.SearchList.push({
                CompareType: "Contains",
                PropertyName: key,
                PropertyValue: searchForm[key],
              });
            }
          }
        });
      }

      if (searchForm.IMEI != "") {
        obj.Params.SearchList.push({
          CompareType: "Contains",
          PropertyName: "IMEI",
          PropertyValue: searchForm.IMEI,
        });
        if (searchForm.IMEI != "" && searchForm.DeviceNo != "") {
          obj.Params.SearchList.push({
            CompareType: "Contains",
            PropertyName: "DeviceNo",
            PropertyValue: searchForm.DeviceNo,
          });
        } else if (searchForm.IMEI != "" && searchForm.ICCID != "") {
          obj.Params.SearchList.push({
            CompareType: "Contains",
            PropertyName: "ICCID",
            PropertyValue: searchForm.ICCID,
          });
        } else if (searchForm.IMEI != "" && searchForm.DeviceName != "") {
          obj.Params.SearchList.push({
            CompareType: "Contains",
            PropertyName: "DeviceName",
            PropertyValue: searchForm.DeviceName,
          });
        }
      } else if (searchForm.DeviceNo != "") {
        obj.Params.SearchList.push({
          CompareType: "Contains",
          PropertyName: "DeviceNo",
          PropertyValue: searchForm.DeviceNo,
        });
        if (searchForm.DeviceNo != "" && searchForm.ICCID != "") {
          obj.Params.SearchList.push({
            CompareType: "Contains",
            PropertyName: "ICCID",
            PropertyValue: searchForm.ICCID,
          });
        } else if (searchForm.DeviceNo != "" && searchForm.DeviceName != "") {
          obj.Params.SearchList.push({
            CompareType: "Contains",
            PropertyName: "DeviceName",
            PropertyValue: searchForm.DeviceName,
          });
        }
      } else if (searchForm.ICCID != "") {
        obj.Params.SearchList.push({
          CompareType: "Contains",
          PropertyName: "ICCID",
          PropertyValue: searchForm.ICCID,
        });
        if (searchForm.ICCID != "" && searchForm.DeviceName != "") {
          obj.Params.SearchList.push({
            CompareType: "Contains",
            PropertyName: "DeviceName",
            PropertyValue: searchForm.DeviceName,
          });
        }
      } else if (searchForm.DeviceName != "") {
        obj.Params.SearchList.push({
          CompareType: "Contains",
          PropertyName: "DeviceName",
          PropertyValue: searchForm.DeviceName,
        });
      }

      const res = await this.$api.axios_http(
        this.$gd.admin.device.getList,
        obj,
        "POST"
      );
      if (isExport) {
        this.sumbitLoading = false;
      } else {
        this.table.loading = false;
      }
      if (res.ReturnCode == 0) {
        if (res.ReturnList && res.ReturnList.length > 0) {
          res.ReturnList.forEach((item) => {
            if (item.UpdateTime) {
              item.UpdateTime = this.$moment(item.UpdateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
            if (item.LastOnLineTime) {
              item.LastOnLineTime = this.$moment(item.LastOnLineTime).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }
        if (isExport) {
          this.exportExcel(res.ReturnList);
        } else {
          this.table.total = res.RecordCount;
          this.table.data = res.ReturnList;
        }
      } else {
        this.$message.error(res.Error);
      }
    },
    async del(DeviceID) {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {
          DeviceID,
        },
      };
      //添加

      const res = await this.$api.axios_http(
        this.$gd.admin.device.delete,
        obj,
        "POST"
      );
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }
    },
    getPrjList() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {},
      };
      return new Promise((resolve) => {
        this.$api
          .axios_http(this.$gd.admin.project.getList, obj, "POST")
          .then((res) => {
            if (res.ReturnCode == 0) {
              this.prjOptions = res.ReturnList;
              resolve();
            } else {
              this.$message.error(res.Error);
            }
          });
      });
    },
    getProductList() {
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: {},
      };
      return new Promise((resolve) => {
        this.$api
          .axios_http(this.$gd.admin.product.getList, obj, "POST")
          .then((res) => {
            if (res.ReturnCode == 0) {
              this.productOptions = res.ReturnList;
              resolve();
            } else {
              this.$message.error(res.Error);
            }
          });
      });
    },
    async sumbit() {
      this.sumbitLoading = true;
      let obj = {
        SessionId: this.SessionId,
        UserId: this.UserId,
        ClientName: "Hoko.Iot.Web.System",
        Params: { ...this.editForm },
      };
      //添加
      let res;
      if (this.editType === 1) {
        res = await this.$api.axios_http(
          this.$gd.admin.device.add,
          obj,
          "POST"
        );
      } else {
        res = await this.$api.axios_http(
          this.$gd.admin.device.edit,
          obj,
          "POST"
        );
      }
      this.sumbitLoading = false;
      if (res.ReturnCode == 0) {
        this.$message.success("操作成功");
        this.editFormVisible = false;
        if (this.editType === 1) {
          this.table.pageNum = 1;
          this.table.pageSize = 15;
        }
        this.getList(this.searchForm);
      } else {
        this.$message.error(res.Error);
      }
    },
    config(DeviceID, DeviceNo, isJump) {
      if (!isJump) {
        this.$store.commit("user/SET_USERINFO_DETAIL", {
          key: "DeviceID",
          value: DeviceID,
        });
        this.$store.commit("user/SET_USERINFO_DETAIL", {
          key: "GatewayCode",
          value: DeviceNo,
        });
      }
      localStorage.setItem("userInfo", JSON.stringify(this.UserInfo));
      this.jumpLoading = true;
      this.jump = true;

      this.$nextTick(() => {
        const iframe = document.querySelector("#jumpIframe");
        // 处理兼容行问题
        if (isJump) {
          let path = this.$route.path; //先获取路由路径
          this.$router.replace(path);
        }

        iframe.onload = () => {
          this.jumpLoading = false;
        };
      });
    },
    //data为需要导出的list内容
    exportExcel(data) {
      this.exportList = [];
      let data_title, key_data;

      // 对数据进行处理
      data.forEach((item) => {
        item.IsConnected = item.IsConnected === true ? "在线" : "离线";
        item.Mode =
          item.Mode === 0 ? "调试模式" : item.Mode === 1 ? "正式使用" : "";
        item.CommunicateMode =
          item.CommunicateMode === 1
            ? "以太网"
            : item.CommunicateMode === 2
            ? "4G"
            : "";
      });
      //表头,有多行表头继续往数组添加，记得进行合并
      data_title = [
        [
          "状态",
          "SN码",
          "设备名称",
          "产品型号",
          "通讯方式",
          "项目名称",
          "状态模式",
          "创建时间",
          "创建人",
          "最后更新时间",
          "IMEI",
          "ICCID",
          "版本",
        ],
      ];

      //表格的值组成的数组
      key_data = [
        "IsConnected",
        "DeviceNo",
        "DeviceName",
        "ProductName",
        "CommunicateMode",
        "PrjName",
        "Mode",
        "UpdateTime",
        "UserName",
        "LastOnLineTime",
        "IMEI",
        "ICCID",
        "Ver",
      ];

      //表头样式设置
      let titleStyle = {
        font: {
          bold: true,
          color: { rgb: "FFFFFF" },
          sz: 12,
        },
        fill: {
          fgColor: { rgb: "2C86D1" },
        },
      };
      if (data && data.length > 0) {
        for (let item of data) {
          let exportData = {};
          key_data.forEach((value) => {
            exportData[value] = item[value] ? item[value] : "";
          });
          this.exportList.push(exportData);
        }
      }
      this.sheet = [];
      let sheetData = {
        multiHeader: data_title,
        table: this.exportList,
        //合并单元格：merges:['A1:A2','A3:A4']
        merges: [],
        keys: key_data,
        sheetName: "设备管理",
        //全局样式
        globalStyle: {},
        //单元格样式
        cellStyle: [
          // {
          //     cell: "A1",
          //     font: {
          //         color: { rgb: "744ca4" },
          //     },
          // },
        ],
      };
      //表头长度
      let titleLength = key_data.length;
      //有几行表头
      let headerLength = data_title.length;
      let cellArr = [];
      for (let i = 1; i <= titleLength; i++) {
        for (let j = 1; j <= headerLength; j++) {
          if (i > 26) {
            let num = i - 26;
            let titleNum = Math.floor(i / 26);
            cellArr.push(
              String.fromCharCode(64 + parseInt(titleNum)) +
                String.fromCharCode(64 + parseInt(num)) +
                j
            );
          } else {
            cellArr.push(String.fromCharCode(64 + parseInt(i)) + j);
          }
        }
      }
      //开始设置样式
      cellArr.forEach((item) => {
        sheetData.cellStyle.push({
          cell: item,
          ...titleStyle,
        });
      });

      //表格全局样式
      this.sheet.push(sheetData);
      //手动调用导出
      this.$refs.excelExport.pikaExportExcel();
      this.exportLoading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  .closeConfig {
    z-index: 10;
    top: 15px;
    right: 40px;
    position: absolute;
  }
  .jump-loader {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .toolBox {
    display: flex;
    // flex-direction: column;
    justify-content: space-between;
    padding: 20px 20px 0;
    box-sizing: border-box;
    .leftBox {
      // margin-bottom: 10px;
      .status{
         /deep/.el-input{
          width: 75px;
        }
      }
      /deep/.el-input{
        width: 130px;
      }
    }
    .rightBox {
      display: flex;
      height: 30px;
    }
  }
  .content {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    padding: 10px;
    padding-top: 0;
    position: relative;
  }
}
</style>
